import React, { useState, useEffect } from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";
import { useTimeline } from "../../context/TimelineProvider";
import { fetchOrders } from "../../api";
import { useTimelineMethods } from "../Timeline/hooks/hooks";

const Header = ({ enterpriseId, divisionId }) => {
  const navigate = useNavigate();
  const {
    selectOrderItemId,
    selectedOrderItemId,
    updateOrders,
    orders,
    addSelectedoperationCard,
  } = useTimeline();

  const { getProductData } = useTimelineMethods(divisionId);

  useEffect(() => {
    updateOrders(divisionId);
  }, [divisionId]);

  const handleSelect = (inputSelectedOrderItemId) => {
    console.log("Selected order item ID:", inputSelectedOrderItemId);
    selectOrderItemId(inputSelectedOrderItemId);
    addSelectedoperationCard(null);
    getProductData();
  };

  const handleOpenTechnologicalCards = () => {
    navigate(`/${enterpriseId}/orders`);
  };

  return (
    <div className="header">
      <button onClick={handleOpenTechnologicalCards}>Назад</button>
      <div className="order-selector">
        <select
          onChange={(event) => handleSelect(event.target.value)}
          className="order-select"
          style={{ height: "100%" }}
        >
          <option value="">Выберите позицию заказа</option>
          {orders?.map((order) => (
            <optgroup
              key={order.order_id}
              label={order.order_name}
              style={{ color: order.is_located ? "green" : "black" }}
            >
              {order.order_items.map((item) => (
                <option
                  key={item.order_item_id}
                  disabled={!item.has_product_sheet}
                  style={{
                    color: item.is_located
                      ? "green"
                      : !item.has_product_sheet
                      ? "red"
                      : "default",
                  }}
                  value={item.order_item_id}
                  selected={item.order_item_id === selectedOrderItemId}
                >
                  {item.nomenclature_name} - {item.nomenclature_quantity}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Header;
